import { LoadingState } from "../../../root-store/api-result.state";
import { DevicesActions } from "../actions";
import { CHDeviceState } from "../clarehome.state";

export const chDevicereducer = (
    state: CHDeviceState = { result: null, uuid: "", callState: LoadingState.init },
    action: DevicesActions.Actions = null
): CHDeviceState => {
    switch (action.type) {
        case DevicesActions.ActionTypes.ResetDevicesCallState: {
            return {
                ...state,
                uuid: null,
                callState: LoadingState.init,
            };
        }

        case DevicesActions.ActionTypes.ClearDevicesState: {
            return {
                result: null,
                uuid: null,
                callState: LoadingState.init,
            };
        }

        case DevicesActions.ActionTypes.GetDevicesSilent:
        case DevicesActions.ActionTypes.GetDevices:
        case DevicesActions.ActionTypes.UpdateDeviceName: {
            return {
                ...state,
                uuid: action.payload.uuid,
                callState: LoadingState.loading,
            };
        }

        case DevicesActions.ActionTypes.DeleteDeviceConfirmationDismiss: {
            return {
                ...state,
                pendingDeletions: [],
            };
        }

        case DevicesActions.ActionTypes.DeleteDevice: {
            let deletions = state?.pendingDeletions || [];
            deletions = [...deletions, action.payload.data.UID];
            return {
                ...state,
                pendingDeletions: deletions,
            };
        }

        case DevicesActions.ActionTypes.DeleteSensor: {
            const deletions = state?.pendingDeletions || [];
            deletions.push(action.payload.securityZone.uid);

            return {
                ...state,
                pendingDeletions: deletions,
            };
        }

        case DevicesActions.ActionTypes.DeleteSensorSuccess: {
            const devices = state.result;
            delete devices[action.result.result.uid];

            const pendingDeletions = state.pendingDeletions;

            if (pendingDeletions) {
                const index = pendingDeletions.findIndex(deviceUid => deviceUid === action.result.result.uid);
                pendingDeletions.splice(index, 1);
            }

            return {
                ...state,
                result: devices,
                callState: LoadingState.loaded,
                pendingDeletions,
            };
        }

        case DevicesActions.ActionTypes.DeleteDeviceSuccess: {
            const devices = state.result;
            delete devices[action.result.result.UID];

            const pendingDeletions = state.pendingDeletions;

            if (pendingDeletions) {
                const index = pendingDeletions.findIndex(deviceUid => deviceUid === action.result.result.UID);
                pendingDeletions.splice(index, 1);
            }

            return {
                ...state,
                result: devices,
                callState: LoadingState.loaded,
                pendingDeletions,
            };
        }

        case DevicesActions.ActionTypes.GetDevicesSuccess: {
            const pendingDeletions = state?.pendingDeletions || null;

            if (pendingDeletions) {
                const index = pendingDeletions.findIndex(deviceUid => deviceUid === action.result.result.UID);
                pendingDeletions.splice(index, 1);
            }

            return {
                ...state,
                result: action.result.result,
                uuid: action.result.uuid,
                callState: LoadingState.loaded,
                pendingDeletions,
            };
        }

        case DevicesActions.ActionTypes.UpdateDeviceNameSuccess: {
            return {
                ...state,
                result: {
                    ...state.result,
                    [action.result.deviceUid]: {
                        ...state.result[action.result.deviceUid],
                        Name: action.result.deviceName, // eslint-disable-line @typescript-eslint/naming-convention
                    },
                },
                callState: LoadingState.loaded,
            };
        }

        default: {
            return state;
        }
    }
};
